import React, { useState, useEffect } from 'react'
import Modal from '@mui/material/Modal'
import { makeStyles } from '@mui/styles'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import AddIcon from '@mui/icons-material/Add'
import { Grid, List, OutlinedInput } from '@mui/material'
import { borderRadius } from '@mui/system'
import TextField from '@mui/material/TextField'
import SearchIcon from '@mui/icons-material/Search'

export default function AlertPlantTypeValueModal({ open = false, id = null, name = null, OnClickInModal = () => { }, OnClickSubmitModal = () => { } }) {
    const classes = useStyles()
    const [plantTypeId, setPlantTypeId] = useState(id)
    const [plantTypeName, setPlantTypeName] = useState(name)

    const onChangeValue = async (id, name) => {
        setPlantTypeId(id)
        setPlantTypeName(name)
    }

    return (
        <div style={{ alignContent: 'center' }}>
            <Modal scrollable
                open={open}
                onClose={OnClickInModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box className={classes.modalStyle}>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Typography id="modal-modal-title" variant="h6" component="h3">
                            แก้ไข ชื่อพันธ์พืช
                        </Typography>
                    </div>
                    <Box sx={{ width: '100%' }}>
                        <Grid container mt={1} rowSpacing={1} >
                            <Grid item xs={3} style={{ display: 'flex', alignItems: 'center' }}>
                                <div >
                                    ชื่อพันธ์พืช
                                </div>
                            </Grid>
                            <Grid item xs={9}>
                                <OutlinedInput size="small" style={{ width: '100%', backgroundColor: '#fff' }}
                                    placeholder={"กรอกชื่อพันธ์พืชใหม่"}
                                    value={plantTypeName}
                                    onChange={(e) => onChangeValue(id, e.target.value)}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                    <Box sx={{ width: '100%' }}>
                        <Grid container mt={3} mb={2} rowSpacing={1}  >
                            <Grid item xs={6} style={{ display: 'flex', justifyContent: 'center' }}>
                                <Button onClick={() => OnClickInModal()} variant="contained" color='inherit' style={{ width: "50%", border: '2px solid #F08E26' }} >ยกเลิก</Button>
                            </Grid>
                            <Grid item xs={6} style={{ display: 'flex', justifyContent: 'center' }}>
                                <Button onClick={() => OnClickSubmitModal(plantTypeId, plantTypeName)} variant="contained" color='primary' style={{ color: '#fff', width: "50%" }} >ตกลง</Button>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Modal>
        </div >
    )
}

const useStyles = makeStyles((theme) => ({
    modalStyle: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        border: '1px solid #000',
        boxShadow: 24,
        backgroundColor: '#12203A',
        color: '#F08E26',
        padding: 20,
        // height: 500,
        // overflow: "scroll",
        borderRadius: 10,
    },
    divLine: {
        height: 1.1, backgroundColor: '#12203A',
        width: '100%', marginTop: 10
    },
}))